import { Icon } from '@spotnana/blocks/src/Icon';
import { IItinerarySelectedLeg } from 'obt-common';

import { CheckoutItemContainer } from '../CheckoutItemContainer';
import CheckoutSectionHeader from '../CheckoutSectionHeader';
import LegDetails from '../LegDetails';
import TravelSummaryLoading from './TravelSummaryLoading';
import { ITravelSummaryContentProps } from './types';

import { icon_color, travel_summary_content } from './styles';

const TravelSummaryContent = ({
  showFareRulesAndAmenities,
  heading,
  itineraryLegs,
  airSelectedItineraryResponseManager,
  fareRulesRequestId,
  shouldShowLLFAlert,
  onFareRulesAndAmenitiesClick,
  onOOPClick,
}: ITravelSummaryContentProps): JSX.Element => {
  if (!airSelectedItineraryResponseManager) {
    return <TravelSummaryLoading heading={heading} />;
  }

  return (
    <CheckoutItemContainer>
      <CheckoutSectionHeader
        icon={<Icon css={icon_color} name="FlightFill" />}
        title={heading}
        dataTestId="travel-summary-section"
      />
      <div css={travel_summary_content} data-testid="air-checkout_summary">
        {itineraryLegs.map((itineraryLeg: IItinerarySelectedLeg, index: number) => (
          <LegDetails
            key={itineraryLeg.legIndex}
            legIndex={itineraryLeg.legIndex}
            airSelectedItineraryResponseManager={airSelectedItineraryResponseManager}
            legNumber={itineraryLeg.legNumber}
            showFareRulesAndAmenities={showFareRulesAndAmenities}
            fareRulesRequestId={fareRulesRequestId}
            airlineReference=""
            shouldShowLLFAlert={shouldShowLLFAlert}
            onFareRulesAndAmenitiesClick={onFareRulesAndAmenitiesClick}
            onOOPClick={onOOPClick}
          />
        ))}
      </div>
    </CheckoutItemContainer>
  );
};

export default TravelSummaryContent;
